import { Routes, Route } from 'react-router-dom'
import TierList from './tierlist/TierList'
import DataManagement from './management/DataManagement'
import SmartDraft from './smartdraft/SmartDraft'
import './App.css'

function App() {
  return (
    <div className="app">
      <main className="main-content">
        <Routes>
          <Route path="/" element={<TierList />} />
          <Route path="/data-management" element={<DataManagement />} />
          <Route path="/smart-draft" element={<SmartDraft />} />
        </Routes>
      </main>
    </div>
  )
}

export default App
